const BASE_URL = "https://core.iran-tarabar.ir/"

export default {
    BASE_URL: BASE_URL,
}